export default "__VITE_ASSET__Ba9wMyRZ__"